module.exports = __webpack_public_path__ + "static/media/welcome1.3610dd17.png";